import styled from '@emotion/styled';

export const CountrySettingsWrapper = styled('div', { label: 'CountrySettingsWrapper' })`
    margin-left: 40px;
`;

export const CountrySettingsHeader = styled('h3', { label: 'CountrySettingsHeader' })`
    margin-top: 10px;
`;
